import IconCard, { CardDescription, CardValue } from "components/company/cards/IconCard";
import CalendarIcon from "components/svg/CalendarIcon";
import getYear from "date-fns/getYear";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";
import { FormattedMessage } from "react-intl";
import colors from "tailwindcss/colors";

interface FoundedYearCardProps {
  issuer:
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | IAmericanCompanyIssuerTopLevelFragment;
}

function getFoundedYear(issuer: FoundedYearCardProps["issuer"]) {
  if (issuer.__typename === "BrazilianRealEstateFund") {
    return parseFloat(issuer.startOfOperation);
  }
  if (!issuer.foundedYear) {
    return null;
  }
  return parseFloat(issuer.foundedYear);
}

export default function FoundedYearCard({ issuer }: FoundedYearCardProps) {
  const foundedYear = getFoundedYear(issuer);
  if (!foundedYear) {
    return null;
  }
  const diffInYears = getYear(new Date()) - foundedYear;

  return (
    <IconCard primaryColor={colors.emerald[500]} secondaryColor={colors.emerald[50]} icon={<CalendarIcon />}>
      {diffInYears >= 1 ? (
        <div className="flex items-baseline">
          <CardValue>{foundedYear}</CardValue>

          <div className="ml-2">
            <small className="font-aeonik font-medium italic text-gray-500">
              <FormattedMessage
                defaultMessage="(há {years, plural, one {# ano} other {# anos}})"
                id="wpDOBx"
                description="Founded year card"
                values={{
                  years: diffInYears,
                }}
              />
            </small>
          </div>
        </div>
      ) : (
        <CardValue>{foundedYear}</CardValue>
      )}

      <CardDescription>
        <FormattedMessage defaultMessage="Fundação" id="vZgvpy" description="Founded year card" />
      </CardDescription>
    </IconCard>
  );
}
